module.exports = __webpack_public_path__ + "img/portrait-100.8fc420be.jpg";